/**
 * Finishing - Images
 *
 * JS pour la gestion des imagess
 *
 * @since       20.10.2015
 * @version     1.0.0.1
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery(document).ready(function() {
    
    jQuery( '.image-popup' ).magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		mainClass: 'mfp-img-mobile',
		image: {
			verticalFit: true,
			titleSrc: ''
		}
    //END jQuery( '.image-popup' ).magnificPopup 
    });
    
    jQuery( '.wpb_single_image a[target="_self"]' ).magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		mainClass: 'mfp-img-mobile',
		image: {
			verticalFit: true,
			titleSrc: ''
		}
    //END jQuery( '.image-popup' ).magnificPopup 
    });

//END jQuery(document).ready
});
